export default {
  placeholder: 'Vybrať formát dát',
};
